module.exports = __webpack_public_path__ + "img/page3-2.0fd92e8b.png";